/* @flow */

import get from 'lodash/get';
import VanillaToasts from 'vanillatoasts';
import MENSAGENS from '../mensagens';

const exibirErro = (error: any): Promise<any> => {
    VanillaToasts.create({
        type: 'danger',
        text: get(error, 'response.data.message'),
        title: MENSAGENS.UTILS.EXIBIR_ERRO.TITULO,
        timeout: 7500,
    });

    return Promise.reject(error);
};

export default exibirErro;
